/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseGalleryImage } from '../../models/response-gallery-image';

export interface GalleryByActivityId$Params {
  id: number;
}

export function galleryByActivityId(http: HttpClient, rootUrl: string, params: GalleryByActivityId$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseGalleryImage>>> {
  const rb = new RequestBuilder(rootUrl, galleryByActivityId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseGalleryImage>>;
    })
  );
}

galleryByActivityId.PATH = '/rest/activity/{id}/gallery';
